/**
 * Configurações do ambiente de produção
 * yarn build:prod
 */
const prodConfig = {
  env: "prod",
  hosts: {
    auth: "https://api.set.rn.gov.br/autbasic/",
    cadastros: "https://api.set.rn.gov.br/cadastros/",
    fiscalizacao: "https://api.set.rn.gov.br/fiscalizacao/",
    usuarios: "https://api.set.rn.gov.br/usuarios/",
    extratofiscal: "https://api.set.rn.gov.br/extrato/",
    nfp: "https://api.set.rn.gov.br/nfp/",
  },
};

export default prodConfig;
